/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Hungarian
export default {
  'feedback-collector.anonymous': 'Ez a visszajelzés névtelenül lesz elküldve. Az Atlassian nem tudja közvetlenül felvenni veled a kapcsolatot ennek ügyében.',
  'feedback-collector.anonymous.title': 'Anonim visszajelzés',
  'feedback-collector.can-be-contacted.label': 'Igen, az Atlassian csapatai felvehetik velem a kapcsolatot, hogy kikérjék a véleményemet az Atlassian termékeinek és szolgáltatásainak fejlesztéséről. Elfogadom az <a>Atlassian adatvédelmi nyilatkozatát</a>.',
  'feedback-collector.cancel-button.label': 'Mégse',
  'feedback-collector.default.custom.textarea.label': 'Mi jár a fejedben?',
  'feedback-collector.enrol-in-research.label': 'Szeretnék részt venni a termékekkel kapcsolatos kutatásban',
  'feedback-collector.feedback-title': 'Oszd meg a véleményedet',
  'feedback-collector.form.bug.label': 'Írd le a hibát vagy az ügyet',
  'feedback-collector.form.comment.label': 'Mondd el, mi jár a fejedben!',
  'feedback-collector.form.empty.label': 'Válassz egy opciót',
  'feedback-collector.form.question.label': 'Mire vagy kíváncsi?',
  'feedback-collector.form.suggestion.label': 'Oszd meg velünk, hogy milyen javításokat szeretnél látni!',
  'feedback-collector.option.bug.label': 'Hibát bejelenteni',
  'feedback-collector.option.comment.label': 'Megjegyzést írni',
  'feedback-collector.option.default.label': 'Visszajelzés választása',
  'feedback-collector.option.default.placeholder': 'Válassz egyet',
  'feedback-collector.option.question.label': 'Kérdést feltenni',
  'feedback-collector.option.suggestion.label': 'Fejlesztéssel kapcsolatos javaslatot tenni',
  'feedback-collector.required.fields.summary': 'A kötelező mezők csillaggal vannak megjelölve',
  'feedback-collector.submit-button.label': 'Visszajelzés elküldése',
  'feedback-collector.success-flag.description': 'Értékes visszajelzésed segítségével folyamatosan fejlesztjük termékeinket.',
  'feedback-collector.success-flag.title': 'Köszönöm!',
  'feedback-collector.summary-placeholder': 'Mondd el, mi jár a fejedben!',
  'proforma-form-builder.feedback-icon-label': 'Visszajelzés',
  'proforma-form-builder.give-feedback': 'Visszajelzés küldése'
};